import { render } from "./HeaderBiblioteca.vue?vue&type=template&id=1aafb708&scoped=true"
import script from "./HeaderBiblioteca.vue?vue&type=script&lang=js"
export * from "./HeaderBiblioteca.vue?vue&type=script&lang=js"

import "./HeaderBiblioteca.vue?vue&type=style&index=0&id=1aafb708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aafb708"]])

export default __exports__